import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, EventEmitter, OnInit, Output } from '@angular/core'
import { MatMenuModule } from '@angular/material/menu'
import { MatTooltipModule } from '@angular/material/tooltip'
import { TranslateModule } from '@ngx-translate/core'
import * as ProjectorTemplatesActions from 'libs/gb-dashboard/presenter/data-access-projector-templates/src/lib/+state/projector-templates.actions'
import { ProjectorTemplatesFacade } from 'libs/gb-dashboard/presenter/data-access-projector-templates/src/lib/+state/projector-templates.facade'
import { ProjectorTemplatesEntity } from 'libs/gb-dashboard/presenter/data-access-projector-templates/src/lib/+state/projector-templates.models'
import { GbDashboardSharedUiModule } from 'libs/gb-dashboard/shared/ui/src/lib/gb-dashboard-shared-ui.module'
import { map } from 'rxjs'
import { GbPresenterCanvasComponent } from '../gb-presenter-canvas/gb-presenter-canvas.component'

@Component({
  selector: 'gb-presenter-templates-list',
  imports: [
    CommonModule,
    MatMenuModule,
    MatTooltipModule,
    TranslateModule,
    GbDashboardSharedUiModule,
    GbPresenterCanvasComponent,
  ],
  templateUrl: './gb-presenter-templates-list.component.html',
  styleUrl: './gb-presenter-templates-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GbPresenterTemplatesListComponent implements OnInit {
  @Output() preview = new EventEmitter<string>()

  projectorTemplates$ = this.projectorTemplatesFacade.allProjectorTemplates$.pipe(
    map((templates) => templates.filter((template) => template.schema_version === 2)),
  )

  _selectedTemplateUuid: string | undefined = undefined

  loaded$ = this.projectorTemplatesFacade.projectorTemplatesLoaded$

  constructor(private projectorTemplatesFacade: ProjectorTemplatesFacade) {}

  ngOnInit(): void {
    this.projectorTemplatesFacade.dispatch(ProjectorTemplatesActions.loadProjectorTemplates())
  }

  selectTemplate(uuid: string) {
    this._selectedTemplateUuid = uuid
    this.projectorTemplatesFacade.dispatch(ProjectorTemplatesActions.selectProjectorTemplate({ uuid }))
  }

  getIsSelected(uuid: string): boolean {
    return uuid === this._selectedTemplateUuid
  }

  onPreviewTemplate(uuid: string, event: Event): void {
    event.stopPropagation()
    this.preview.emit(uuid)
  }

  getTemplateBackgroundImageUrl(template: ProjectorTemplatesEntity): string | null {
    const image = template.background_image
    if (!image) {
      return null
    }

    return image.medium_image || image.small_image || image.thumbnail_image || image.image_url || null
  }
}
